import _ from "lodash";
import React from "react";
import { AttachmentList } from "AppComponents/Attachment";
import classes from "./AttachmentListWrapper.scss";
import { getOrgResourcesAttachments } from "Utils";

const AttachmentListWrapper = props => {
  const {
    organizationResources = [],
    toggleSelectResources,
    selectedResources,
    testId,
  } = props;
  const updateSelectedItems = selectedAttachments => {
    const selectedOrganizationResources = _.map(
      selectedAttachments,
      attachment => {
        return _.find(organizationResources, oR =>
          attachment?.id
            ? _.isEqual(_.get(oR, "attachment.id", null), attachment?.id)
            : false
        );
      }
    );
    toggleSelectResources(selectedOrganizationResources);
  };
  return (
    <div className={classes.container}>
      <AttachmentList
        selectedItems={_.map(
          selectedResources,
          resource => resource.attachment
        )}
        updateSelectedItems={updateSelectedItems}
        value={getOrgResourcesAttachments({ resources: organizationResources })}
        cardType={"verticalHorizontal"}
        selectedItemType={"OBJECT"}
        itemStyles={{
          backgroundPosition: "center",
        }}
        containerStyle={{
          gridGap: "40px 24px",
        }}
        cardStyle={{
          height: 160,
        }}
        mode={"select"}
        testId={testId}
      />
    </div>
  );
};

export default AttachmentListWrapper;
